import { Directive, ElementRef, Renderer2, OnInit, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';

@Directive({
  selector: '[appCurrencyMask]'
})
export class CurrencyMaskDirective implements OnInit {
  constructor(
    private ngControl: NgControl,
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    private currencyPipe: CurrencyPipe
  ) {}

  ngOnInit() {
    // Subscribe to control value changes
    this.ngControl.control?.valueChanges.subscribe(value => {
      if (value !== null && value !== undefined && value !== '') {
        // Format only if the input is not focused
        if (document.activeElement !== this.el.nativeElement) {
          const formatted = this.currencyPipe.transform(value, 'USD', 'symbol', '1.2-2') ?? '';
          this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
        }
      }
    });
  }

  // On focus, show the number without formatting
  @HostListener('focus')
  onFocus() {
    const current = this.ngControl.control?.value;
    if (current !== null && current !== undefined && current !== '') {
      this.renderer.setProperty(this.el.nativeElement, 'value', current.toString());
    }
  }

  // If the input loses focus, format the number as currency
  @HostListener('blur')
  onBlur() {
    const raw = this.el.nativeElement.value;
    if (!raw) {
      this.ngControl.control?.setValue(null);
      return;
    }

    let numeric = raw.replace(/[^0-9.]/g, '');
    if (numeric.includes('.')) {
      const [intPart, decPart] = numeric.split('.');
      numeric = intPart + '.' + (decPart ?? '').slice(0, 2);
    }

    const num = parseFloat(numeric);
    if (isNaN(num)) {
      this.ngControl.control?.setValue(null);
      this.renderer.setProperty(this.el.nativeElement, 'value', '');
      return;
    }

    this.ngControl.control?.setValue(num); // Clean value without formatting
    const formatted = this.currencyPipe.transform(num, 'USD', 'symbol', '1.2-2') ?? '';
    this.renderer.setProperty(this.el.nativeElement, 'value', formatted); // Value with formatting
  }
}